/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const LoanCalculatorSm = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 35 36" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <path d="M22.71 13h3v3h-3zM27.71 18h3v8h-3zM17.71 13v.39a13.09 13.09 0 0 1 3 2.5V13zM25.71 18h-3v.89a13.7 13.7 0 0 1 .8 2.11h2.2zM25.71 23h-1.8a15.11 15.11 0 0 1 .09 1.51 14.71 14.71 0 0 1-.09 1.49h1.8z" /><path d="M32.71 0h-17a2 2 0 0 0-2 2v9.8a12.46 12.46 0 0 1 2 .6V2h17v26h-9.2a12.6 12.6 0 0 1-.74 2h9.94a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" /><path d="M27.71 13h3v3h-3zM17.71 4h13v7h-13z" /><path d="M14.54 29.8a2.25 2.25 0 1 1 2.25-2.25 2.25 2.25 0 0 1-2.25 2.25zm0-3a.75.75 0 0 0 0 1.5.75.75 0 1 0 0-1.5zM8 23.26A2.25 2.25 0 1 1 10.25 21 2.25 2.25 0 0 1 8 23.26zm0-3a.75.75 0 1 0 .75.75.75.75 0 0 0-.75-.75zM6.91 29.54a.94.94 0 0 1-.67-1.6l8.19-8.19a.94.94 0 0 1 1.6.66.94.94 0 0 1-.27.66l-8.19 8.19a.92.92 0 0 1-.66.28z" fill={secondaryColor} /><path d="M11 35.51a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9z" fill={secondaryColor} />
      </g>
    </svg>
  </span>
);

LoanCalculatorSm.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

LoanCalculatorSm.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default LoanCalculatorSm;
